export const getBUSDAddress = () => {
    // main-net
    return "0xe9e7cea3dedca5984780bafc599bd69add087d56";
    // test-net
    // return "0xe10fecd363459964cecff2e91feb3cdee3aa7e21";
};

export const getUSDTAddress = () => {
    // main-net
    return "0x55d398326f99059fF775485246999027B3197955";
};
export const getMMProAddress = () => {
    // main-net
    return "0x6067490d05F3cF2fdFFC0e353b1f5Fd6E5CCDF70";
    // test-net
    // return "0xa8892b044ece158cb4869b59f1972fa01aae6d2e"
};

export const getPancakeRouterAddress = () => {
    return "0x10ed43c718714eb63d5aa57b78b54704e256024e";
};